import { InputConfigDate } from "../model/form/dto/InputDateConfigDto";
import { InputTypes } from "../model/form/types/InputTypes.enum";
import { isBlankValue } from "./isBlankValue";

/**
 * Mirrors UtilsService.isCustomDateInput on the API - the explicit
 * `enabled` flag is authoritative once set; `== null` catches both
 * undefined (this field never existed) and null, falling back to
 * inferring it from whether days/hours/timezone are configured at all, so
 * a date input saved before this flag existed keeps behaving exactly as
 * it did before.
 */
export function isCustomDateInput(
  type: string | undefined,
  dateInputConfig: InputConfigDate | undefined,
): boolean {
  if (type?.toLowerCase() !== InputTypes.DATE.toLowerCase()) {
    return false;
  }

  if (dateInputConfig?.enabled != null) {
    return Boolean(dateInputConfig.enabled);
  }

  return Boolean(
    !isBlankValue(dateInputConfig?.days) ||
      !isBlankValue(dateInputConfig?.hours) ||
      !isBlankValue(dateInputConfig?.timezone),
  );
}
